/* eslint-disable */
const terms = "He leído y acepto los {{terms_and_conditions}} de Time Out"
export default {
  'es-ES': {
    common: {
      NAME_HOLDER: "Nombre *",
      LAST_NAME_HOLDER: "Apellido *",
      EMAIL_HOLDER: "Correo electrónico *",
      PASS_HOLDER: "Crear contraseña *",
      REPEAT_PASS_HOLDER: "Repetir contraseña *",
      BUTTON_EMAIL_SIGN_UP: "Inicia sesión con tu correo electrónico",

      TERMS_AND_CONDITIONS: "términos y las condiciones",
      PRIVACY_POLICY: "política de privacidad",

      NEWSLETTER_CONSENT: "Acepto recibir comunicaciones relevantes de Time Out, incluidas noticias, eventos, ofertas y promociones de clientes.",
      TERM_OF_USE: terms,
      TERM_OF_USE_WITH_NEWSLETTERS: "Acepto los {{terms_and_conditions}} de Time Out, incluyendo el registro a la newsletter.",

      HEADER_TITLE: "Crear una cuenta de Time Out",
      JOIN_FB: "Únete con Facebook",
      JOIN_TW: "Únete con Twitter",
      JOIN_GG: "Únete con Google",
      JOIN_EM: "Únete con tu correo electrónico",
      ALREADY_HAVE: "¿Ya tienes una cuenta en Time Out?",
      CREATE_ACCOUNT_LOG_IN: "Conéctate",

      SIGN_IN_TITLE: "Inicia sesión",
      SIGN_IN_FB: "Inicia sesión con Facebook",
      SIGN_IN_TW: "Inicia sesión con Twitter",
      SIGN_IN_GG: "Inicia sesión con Google",
      SIGN_IN_EM: "Inicia sesión con tu correo electrónico",
      YOUR_EMAIL: "Tu correo electrónico",
      YOUR_PASSWORD: "Tu contraseña",
      REMEMBER: "Recuérdame",
      FORGOT: "¿Olvidar?",
      HAVE_ACCOUNT_YET: "¿Aún no tienes una cuenta de Time Out?",
      JOIN_HERE: "Únete aquí",
      ALMOST_THERE: "Ya casi está",

      FORGOT_HEADER: "¿Has olvidado tu contraseña?",
      FORGOT_SUBTITLE: "No hay problema. Introduce tu dirección de correo electrónico abajo y te enviaremos un enlace para restaurarla",
      SEND_LINK: "Envía el enlace",

      RECEIVE_EMAIL: "Gracias, recibirás pronto un correo electrónico",
      MANAGE_ACCOUNT: "Administra tu cuenta",
      EDIT_DETAILS_HERE: "Puedes editar los detalles de tu cuenta aquí",
      FIRST_NAME: "Nombre",
      LAST_NAME: "Apellido",
      SCREEN_NAME: "Nombre de perfil",
      EMAIL: "Correo electrónico",
      ACCOUNT_DETAILS: "Detalles de la cuenta",
      PASSWORD: "Contraseña",
      SAVE_CHANGES: "Guardar cambios",
      UPLOAD_PIC: "Sube una nueva foto de perfil",
      CHOOSE_PHOTO: "Escoge una foto de tu dispositivo de máximo 2MB.",
      CLOSE_ACCOUNT: "Cerrar mi cuenta",
      PASSWORD_BELOW: "Puedes cambiar tu contraseña abajo",
      CURRENT_PASSWORD: "Contraseña actual",
      NEW_PASSWORD: "Nueva contraseña",
      REPEAT_PASSWORD: "Repite la nueva contraseña",
      CONFIRM_PASSWORD: "Confirmar contraseña",

      OOPS: "Ups,",
      ERROR_404_OCCURED: "Ocurrió un error…",
      ERROR_404_INFO: "Se ha movido la página o ya no existe.",
      ERROR_500_TITLE: "El servidor ha vuelto a",
      SMTH_BROKEN: "Algo no funciona.",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "Por favor, dinos qué estabas haciendo cuando ocurrió este error. Lo arreglaremos tan pronto como sea posible. Lamentamos cualquier inconveniente causado.",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Por favor, introduce una dirección válida de correo electrónico",
      FIRST_NAME_ERROR: "Por favor, introduce tu nombre",
      LAST_NAME_ERROR: "Por favor, introduce tu apellido",
      TERM_OF_USE_ERROR: "Debe aceptar nuestros términos de uso",
      SIGN_IN_VALIDATION_ERROR: "Correo electrónico o contraseña incorrectos. Por favor, inténtalo de nuevo",
      ACCOUNT_PASSWORDS_VALIDATION: "No coincide la contraseña",
      WAS_IT: "¿Ha sido algo que hemos hecho?",
      DELETE_ACCOUNT_TEXT: "Lamentamos que quieras borrar tu cuenta. Si hay algo por lo que quieres salir, ",
      DELETE_ACCOUNT: "Borrar cuenta",
      CANCEL: "Cancelar",

      UPDATE_PASSWORD: "Actualice su contraseña",
      PASSWORD_UPDATE_SUCCESS: "Tu contraseña ha sido actualizada",
      ERROR_PASSWORD_LENGTH: "La contraseña debe contener al menos 6 caracteres",

      ERROR_MISSING_SITE_PARAMETER: "Falta el parámetro de aplicación requerido: site",
      ERROR_ALREADY_REGISTERED: "Ya te habías registrado previamente usando tu email. Por favor, usa {{email}} para acceder en tu cuenta",

      BACK: 'Atrás',
      HERE: 'aquí',
      GP_FORGOT_HEADER: 'Olvidaste tu contraseña?',
      GP_PLANS_THANK_YOU_HEADER: 'Gracias por su pedido!',
      GP_PLANS_THANK_YOU_DESCRIPTION: 'Un correo electrónico de confirmación está en camino a {{email}}',
      GP_PLANS_THANK_YOU_CONTINUE: 'Continuar al sitio',
      GP_FORGOT_SUBTITLE: `No hay problema. Solo introduce tu correo electrónico a continuación y te enviaremos un enlace para restablecerlo`,
      GP_SEND_LINK: 'Restablecer mi contraseña',
      GP_YOUR_EMAIL: 'Su dirección de correo electrónico',
      GP_RECEIVE_EMAIL: `Gracias, si ya te has registrado previamente con nosotros usando esta dirección de correo electrónico recibirás un correo electrónico en breve.`,
      GP_LOGIN_TITLE: 'Iniciar sesión',
      GP_EXP_TITLE: " Escoge una opción",
      GP_PLAN_1_TITLE: "Comprar y navegar sin anuncios",
      GP_PLAN_1_BULLET_1: "Una suscripción sin anuncios a Time Out te permite leer el sitio web de Time Out sin publicidad.",
      GP_PLAN_1_BULLET_2: "No compartiremos ninguno de sus datos con anunciantes.",
      GP_PLAN_1_CTA: "Paga por rechazar anuncios por 2€",
      GP_PLAN_2_TITLE: "Visitar Time Out con anuncios personalizados",
      GP_PLAN_2_BULLET_1: `Haz clic en "Vuelve a Aceptar todo" si no quieres suscribirte a Time Out Ad Free`,
      GP_PLAN_2_CTA: `Volver a "Aceptar todo"`,
      GP_HAVE_ACCOUNT_YET: "Ya tienes una cuenta Time Out Ad Free?",
      GP_QA_TITLE: "Cualquier pregunta?",
      GP_QA_QUESTION_1: "¿Qué incluye exactamente Time Out sin anuncios?",
      GP_QA_ANSWER_1_PART1: "Por un pago único de 2 €, disfrutarás de Time Out completamente libre de anuncios. Este es un pago de una sola vez y limitado a 30 días desde la fecha de compra.<br /><br /> No verás  anuncios de display tradicionales, ventajas emergentes ni anuncios de vídeo pre-roll que suelen aparecer en nuestra página web. Es tu billete para un viaje sin interrupciones mientras disfrutas de lo mejor de la ciudad. Cuando decimos \"sin seguimiento\", queremos decir que no utilizaremos cookies ni tecnologías similares para seguir tu actividad de navegación con fines de publicidad personalizada ni compartir datos con terceros. Sin embargo, sí que recopilamos datos anónimos y agregados para asegurarnos que nuestra página web funcione correctamente, para entender cómo está funcionando nuestro contenido y para mejorar continuamente tu experiencia, siempre de acuerdo con nuestra ",
      GP_QA_ANSWER_1_PART2: ".<br/><br/><strong>Nota importante:</strong> A pesar de que eliminamos los anuncios de display, esto no afecta el contenido editorial propio de Time Out, que puede incluir reportajes patrocinados claramente indicados, artículos nativos o enlaces de afiliados a eventos y productos que recomendamos editorialmente. Estos forman parte de nuestra oferta editorial, no de publicidad de terceros.",
      GP_QA_QUESTION_2: "¿Time Out sin anuncios funcionará en todos mis dispositivos?",
      GP_QA_ANSWER_2_PART1: "¡Por supuesto! Time Out sin anuncios está inteligentemente vinculado a tu cuenta de Time Out. Así, tanto si estás planificando tu próxima aventura desde el ordenador, buscando inspiración en tu tablet o consultando qué pasa en el móvil, solo tienes que iniciar sesión con tus credenciales habituales de Time Out en cualquier navegador web compatible, y la experiencia sin anuncios se reproducirá. <br><br/>¿Ya tienes una cuenta de Time Out Ad-Free? Inicia sesión",
      GP_QA_ANSWER_2_PART2: "",
      GP_QA_QUESTION_3: "¿Cómo accedo a Time Out sin anuncios si he iniciado sesión en un dispositivo pero me muevo a otro?",
      GP_QA_ANSWER_3_PART1: "¡No hay problema! Asegúrate de haber iniciado sesión a tu cuenta de Time Out en el nuevo dispositivo. Si sigues viendo anuncios, refresca la página o haz clic en el enlace de 'Gestionar cookies' al pie de página de nuestra web. Esto confirmará tu estado de inicio de sesión y aplicará automáticamente tus ventajas de 'sin anuncios' y 'sin seguimiento'.\n¿Ya tienes una cuenta? Inicia sesión ",
      GP_QA_ANSWER_3_PART2: ".",
      GP_QA_QUESTION_4: "¿Cómo puedo contactar con atención al cliente?",
      GP_QA_ANSWER_4_PART1: "Si experimentas cualquier problema, nuestro equipo de soporte está aquí para ayudarte. Envíanos un correo electrónico a support@timeout.com. Nuestro objetivo es responder a todas las consultas rápidamente. ",
      GP_QA_ANSWER_4_PART2: ".",
      GP_QA_QUESTION_5: "¿Cuál es su política de reembolso?",
      GP_QA_ANSWER_5_PART1: "Nuestra política de reembolso completa, incluyendo cualquier reembolso prorrateado para ciertas circunstancias (por ejemplo, si cancelas dentro de un período de desistimiento), se detalla en nuestros ",
      GP_QA_ANSWER_5_PART2: ".",
      GP_CONFIRM_PAY: "Confirmar y pagar",
      GP_EDIT: "Editar",
      GP_TOTAL: "Total",
      GP_ORDER_TOTAL: "Total del pedido",
      GP_MONTH: "Más",
      GP_CHK_PLAN_1_TITLE: "Time Out Ad-Free",
      GP_YOUR_DETAILS: "Tus datos",
      GP_PAYMENT_METHOD: "Método de pago",
      GP_NAME_CARD: "Nombre del titular de la tarjeta",
      GP_CARD_NUMBER: "Número de tarjeta",
      GP_EXPIRY_DATE: "Fecha de caducidad",
      GP_CVV: "CVV",
      GP_POST_CODE: "Código postal",
      GP_AD_FREE_TERMS_AND_CONDITIONS: "Términos y condiciones de Time Out sin anuncios",
      GP_TERMS_AND_CONDITIONS: "términos de uso",
      GP_PRIVACY_POLICY: "aviso de privacidad",
      GP_ORDER_TERMS: "Al completar este pedido, acepto los {{terms_and_conditions}}, el {{privacy_policy}} y los {{ad_free_terms_and_conditions}}.",
      GP_ORDER_DISCLAIMER: "<strong>\"Sin anuncios\"</strong>: el servicio sin anuncios está diseñado para eliminar los anuncios gráficos, los anuncios emergentes y los anuncios de vídeo previos a los vídeos que suelen aparecer en las áreas de contenido editorial de nuestro sitio web durante el periodo de acceso.",
      GP_PAY_VALUE: "Pagar {{value}}",
      BRAINTREE_cardholderName_ERROR: "error en el nombre del titular de la tarjeta",
      BRAINTREE_number_ERROR: "error en el número de tarjeta",
      BRAINTREE_expirationDate_ERROR: "error en la fecha de caducidad de la tarjeta",
      BRAINTREE_cvv_ERROR: "error en la fecha CVV de la tarjeta",
      BRAINTREE_postalCode_ERROR: "error en el código postal de la tarjeta",
      BRAINTREE_generic_ERROR: "error genérico",
      PAYMENT_AUTHORIZATION_FAILED: "Oops! Pago fallido. Por favor, revisa tus datos e inténtalo de nuevo.",
      GP_THANK_YOU_LOGIN_FAIL_MESSAGE: "Tus datos de inicio de sesión son correctos, pero Time Out ya no ofrece una suscripción sin anuncios."
    },
    'es-barcelona': { TERM_OF_USE: terms, },
    'es-madrid': { TERM_OF_USE: terms, },
    'es-girona': { TERM_OF_USE: terms, },
  }
}



// WEBPACK FOOTER //
// ./translations/es-ES.js